import { BasicSuccessPageForDataForm } from "@component/assets/AbstractLeadForm/Steps/BasicSuccessPageForDataForm";
import {
	faFaceSmile as farFaceSmile,
	faThumbsUp as farThumbsUp,
} from "@awesome.me/kit-3777c2145e/icons/classic/regular";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import type { ReactNode } from "react";
import React from "react";

export class SuccessPage extends BasicSuccessPageForDataForm {
	public static defaultProps = {
		...BasicSuccessPageForDataForm.defaultProps,
		relativeUrl: "/szemelyi-kolcson/adatbekero",
	};

	protected renderDataFormBody(): ReactNode {
		return super.renderDataFormBody("Itt folytasd az igénylésed", "Plussz adataiddal eléred", [
			{
				icon: <FontAwesomeIcon icon={farFaceSmile} />,
				content: (
					<>
						előzetes <strong>hitelminősítésed eredményét</strong>
					</>
				),
			},
			{
				icon: <FontAwesomeIcon icon={farThumbsUp} />,
				content: (
					<>
						személyre szabott <strong>hitelajánlatodat</strong>
					</>
				),
			},
		]);
	}

	protected renderDataFormFooter(): ReactNode {
		return super.renderDataFormFooter("Igénylés folytatása");
	}

	protected getComponentName(): string {
		return `${super.getComponentName()}.SuccessPage`;
	}
}
